import axios from 'axios';
import {add2basket} from './basket';
import {rootUrl} from './config';

function bindSearchEvents(){
  $("div.product-more-btn button[name='more_products']").on("click", function(evt){
    loadMoreProducts(this);
  });
  $("div.article-more-btn button[name='search_more_articles']").on("click", function(evt){
    loadMoreArticles(this);
  });
  let cHeight=$("#product_search .product-search-container").height()-10;
  $("#product_search .facet-container.products-type").css({"height": `${cHeight}px`});
}

function sortByProduct(ele){
  let url=`${rootUrl}/search/sortbyproduct`;
  let params = {
    keyword: $("input[name='search_keyword']").val(),
    sortby: $(ele).data("sortby"),
    ft: $("#product_search input[name='search_keyword']").val()
  };
  
  axios({url:url,method:'POST',data: params}).then(function(res) {
    console.log(res.data);
    if(res.data.status && res.data.html){
      $("#product_search .product-search-container .product-cell").remove();
      $(res.data.html).insertAfter($("#product_search .product-search-container .sort-container")).find("button.btn-addcart").on("click",function(evt){
        evt.stopPropagation();
        add2basket(this,$(this).data("pid"),"search-more");
      });
      $("input[name='ploaded_page']").val(res.data.page);
      if(!res.data.isMore) $("#product_search div.product-more-btn").addClass("hide");
    }
  }).catch(function(err){
    console.log(err);
  });
}

function loadMoreProducts(ele){
  let url=`${rootUrl}/search/moreproduct`;
  let params = $(ele).data("para");
  params.page = $("input[name='ploaded_page']").val();
  $(".search-result-container .product-search-container").css('opacity', '0.6');
  axios({url:url,method:'POST',data: params}).then(function(res) {
    //console.log(res.data);
    if(res.data.status && res.data.html){
      $(res.data.html).insertBefore($(ele).closest("div.product-more-btn")).find("button.btn-addcart").on("click",function(evt){
        evt.stopPropagation();
        if(!$(this).hasClass("read-more")) add2basket(this,$(this).data("pid"),"search-more");
        else {
          location.href=$(this).closest(".product-wrapper").find("a.product-url").attr("href");
        }
      });
      updateProductPageInc(res.data.page);
      if(!res.data.isMore) $(ele).closest("div.product-more-btn").addClass("hide");
      const url = new URL(location);
      url.searchParams.set("page", Number(params.page)+1);
      history.pushState({}, "", url);
      // For redraw this element
      $(".search-result-container .product-search-container").animate({'opacity': 1},500);
    }
  }).catch(function(err){
    console.log(err);
  });
}

function updateProductPageInc(pageNum) {
  $("input[name='ploaded_page']").val(pageNum);
  // Sort items
  $("div.sort-container ul>li.sort-item a").each(function(idx){
    let href = $(this).attr('href');
    href = String(href).replace(/page\=\d+$/gi,`page=${pageNum}`);
    //console.log(href);
    $(this).attr('href',href);
  });
  $("div.facet-container .articles-category ul>li a").each(function(idx){
    let href = $(this).attr('href');
    href = String(href).replace(/page\=\d+$/gi,`page=${pageNum}`);
    //console.log(href);
    $(this).attr('href',href);
  });
}

function updateArticlePageInc(pageNum) {
  $("input[name='aloaded_page']").val(pageNum);
  // Sort items
  $("div.sort-container ul>li.sort-item a").each(function(idx){
    let href = $(this).attr('href');
    href = String(href).replace(/ap\=\d+/gi,`ap=${pageNum}`);
    //console.log(href);
    $(this).attr('href',href);
  });
  $("div.facet-container .products-type ul>li a").each(function(idx){
    let href = $(this).attr('href');
    href = String(href).replace(/ap\=\d+/gi,`ap=${pageNum}`);
    //console.log(href);
    $(this).attr('href',href);
  });
}

function loadMoreArticles(ele){
  let url=`${rootUrl}/search/morearticle`;
  let params = $(ele).data("para");
  params.page = $("input[name='aloaded_page']").val();
  $(".search-result-container .article-search-container").css('opacity', '0.6');
  axios({url:url,method:'POST',data: params}).then(function(res) {
    //console.log(res.data);
    if(res.data.status && res.data.html){
      $(res.data.html).insertBefore($(ele).closest("div.article-more-btn"));
      updateArticlePageInc(res.data.page);
      if(!res.data.isMore) $(ele).closest("div.article-more-btn").addClass("hide");
      // For redraw this element
      $(".search-result-container .article-search-container").animate({'opacity':1},500);
    }
  }).catch(function(err){
    console.log(err);
  });
}
function filterProductByType(ele){
  let url=`${rootUrl}/search/filterproduct`;
  let params = {
    keyword: $("input[name='search_keyword']").val(),
    ft: $(ele).data("id"),
    limit: $(ele).data("limit")
  };
  
  axios({url:url,method:'POST',data: params}).then(function(res) {
    console.log(res.data);
    if(res.data.status && res.data.html){
      $("#product_search .product-search-container .product-cell").remove();
      $(res.data.html).insertAfter($("#product_search .product-search-container .sort-container")).find("button.btn-addcart").on("click",function(evt){
        evt.stopPropagation();
        add2basket(this,$(this).data("pid"),"search-more");
      });
      $("input[name='ploaded_page']").val(res.data.page);
      if(!res.data.isMore) $("#product_search div.product-more-btn").addClass("hide");
    }
  }).catch(function(err){
    console.log(err);
  });
}

function filterArticleByCategory(ele){
  let url=`${rootUrl}/search/filterarticle`;
  let params = {
    filter: {
      active: 1,
      keyword: $("input[name='search_keyword']").val()
    },
    fc: $(ele).data("id"),
    limit: $(ele).data("limit")
  };
  
  axios({url:url,method:'POST',data: params}).then(function(res) {
    console.log(res.data);
    if(res.data.status && res.data.html){
      $("#article_search .article-search-container .content-mainbox").remove();
      $(res.data.html).insertAfter($("#article_search .article-search-container .title"));
      $("input[name='aloaded_page']").val(res.data.page);
      if(!res.data.isMore) $("#article_search div.article-more-btn").addClass("hide");
    }
  }).catch(function(err){
    console.log(err);
  });
}

export {bindSearchEvents};